module.exports = __webpack_public_path__ + "static/skullAR-f491ae3ef85a4eb7c433edb6973c80a3.mp4";